"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDOMFrameScheduler = void 0;
/**
 * Wraps a render function in a call to {@link Window.requestAnimationFrame}. This
 * avoids unnecessary re-renders, for example if {@link Pipeline.onResourceChanged}
 * fires multiple times before the next browser frame is painted.
 */
function createDOMFrameScheduler(render) {
    var requested = false;
    var requestedId = null;
    return {
        requestRender: function () {
            if (!requested) {
                requested = true;
                requestedId = requestAnimationFrame(function (time) {
                    requested = false;
                    requestedId = null;
                    render(time);
                });
            }
        },
        cancelRender: function () {
            if (requestedId) {
                cancelAnimationFrame(requestedId);
            }
        }
    };
}
exports.createDOMFrameScheduler = createDOMFrameScheduler;
//# sourceMappingURL=createDOMFrameScheduler.js.map